<div class="legal-content">
  <h5>TERMS &amp; CONDITIONS - EDGELESS CASINO</h5>
  <p></p>
  <ol>
    <li>GENERAL
      <ol>
        <li>
          Your acceptance of the Terms by clicking the tic box means that you are bound by the Terms and that you have
          entered into a contractual relationship with Edgeless. You must read these Terms carefully in their entirety
          before ticking the box for acceptance. If you do not agree with any provision of these Terms you must not use
          or
          continue to use the Services. 2. Edgeless reserves the right to amend the Terms from time to time. You will be
          notified about&nbsp;any material change to the Terms and we may require you to re-confirm acceptance to the
          updated Terms upon your first access to the Website following the change of the Terms. If you do not agree
          with
          the change, you must immediately cease the use of the Services and the termination provisions below will
          apply.&nbsp;Continued use of the Services indicates your agreement with changes. Bets not settled prior to the
          changed Terms taking effect will be subject to the pre-existing Terms.
        </li>
        <li>
          Use of the Services is restricted to an individual of legal age as determined in the jurisdiction in which the
          player resides, who has registered as a player and who holds a Player’s Account with Edgeless. Under no
          circumstances may a person register or play under the age of 18 years. If any funds are deposited by an
          underage
          individual, the funds excluding any winnings will be returned to the individual.
        </li>
        <li>
          You participate in the casino games strictly in your personal non-professional capacity for recreational and
          entertainment purposes only.
        </li>
      </ol>
    </li>
    <li>PLAYER’S ACCOUNT AND USE OF THE SERVICES
      <ol>
        <li>
          In order to use the Services you have to register personally and must open an account (“Player's Account”).
        </li>
        <li>Only one Player's Account is allowed per player.</li>
        <li>Edgeless reserves the right to refuse any application for a Player's Account at its sole discretion.</li>
        <li>
          Multiple accounts that are linked by the same device, household or IP address are not allowed. In case it is
          noted that there are similar accounts, such Players’ Accounts may be closed by Edgeless at its sole discretion
          and
          any funds on these Players’ Accounts will be frozen. Furthermore, these Player Accounts may be closed by
          Edgeless
          at its own discretion.
        </li>
        <li>
          Upon registration you must provide certain personal information (“Personal Data”) to Edgeless, which must be
          valid, complete and correct. You will also be asked to upload proof of identity (passport, voter’s ID card,
          driver’s license) and / or under decision of Edgeless - proof of residence (electricity of landline telephone
          bill, cable TV, letter from employer or any recognized authority certifying your address). If any of the
          information that you provide to Edgeless is false or incomplete, your registration will be refused.
        </li>
        <li>
          Immediately after registration Edgeless sends out a verification email. You must click on the provided link to
          verify your e-mail address.
        </li>
        <li>
          You can view your personal data provided to Edgeless at all times and you must keep these personal data
          up-to-date, accurate and complete. Edgeless may at any time request for updated personal documentation to
          verify
          existing personal data and changes therein requested by you.
        </li>
        <li>
          Upon registration, you must select a username and a password, which shall be used when accessing the
          Website and your Player's Account. You will not allow any other person to use your Player's Account, to access
          the
          Website and/or use the Services or to accept any prize.
        </li>
        <li>You will not share with any third party your
          account information, user-name and password, which are secret and confidential. You are solely responsible for
          any
          and all use of the Services through your user-name and password. In case you become aware of any known or
          suspected unauthorized use of your Player’s Account or breach of security you are required to immediately
          notify
          Edgeless hereof in order to suspend your Player's Account. Any unauthorized use of your user-name or password
          shall be deemed as your use and you are responsible for all charges to your Player’s Account until such
          notification is made to Edgeless. Should you in any manner, whether purposely or not, disclose your username
          and/or password, Edgeless will not be liable for any loss or damage as a result thereof.
        </li>
        <li>It is strictly
          prohibited to use any automated software and/or computer system in direct or indirect conjunction with the
          Services, including but not limited to the performance of actions such as sending information from your
          computer
          to another computer with installed and active software and/or systems designed to grant you an unfair
          disadvantage.
        </li>
        <li>You participate in the Casino Games on your own behalf and not on behalf of any other person.</li>
        <li>Edgeless prohibits player collusion.</li>
        <li>
          Should you become aware of possible errors or incompleteness in the software of the Website or the Services,
          you agree to refrain from taking advantage thereof and to report any error or incompleteness immediately to
          Edgeless by sending an email to support@edgeless.io. Should you fail to fulfill the obligations stated in this
          clause, Edgeless has a right to claim from you full compensation of all costs related to the error or
          incompleteness, including but not limited to any costs incurred due to the respective error and/or
          incompleteness
          and the failed notification of the error or incompleteness by you.
        </li>
        <li>
          Edgeless reserves the right to retain payments from you and to bring criminal charges against you if suspicion
          or evidence exists of manipulation of the Website or the Services, including but not limited to the Casino
          Games,
          or attempts thereto.
        </li>
      </ol>
    </li>
    <li>EDGELESS (EDG) TOKENS
      <ol>
        <li>
          You can play with utility tokens issued by Edgeless (“EDG Tokens”) only. Edgeless does not accept cash
          payments
          to the Player's Account.
        </li>
        <li>
          You understand that the value of Edgeless Token can vary depending on the market value at any time and
          Edgeless takes no responsibility for any claim with respect to the value of Edgeless Tokens. 3. You confirm
          that
          the Edgeless Tokens you deposit into your Personal Account are not affected by any illegality and, in
          particular,
          do not originate from any illegal activity or source. 4. You shall deposit Edgeless Tokens into your Personal
          Account before you can start playing the Casino Games. Transfer and deposit fees are for the account of the
          player
          and depend on the fee structure and size on the Blockchain.
        </li>
      </ol>
    </li>
    <li>
      EDGELESS CASINO GAMES
      <ol>
        <li>On the Website Edgeless offers the following Casino Games: Blackjack, Poker and Dice.</li>
        <li>
          The Casino Games shall be played in the same manner as in any other setting, i.e. players must be courteous
          and
          avoid rude and obscene comments.
        </li>
        <li>
          Further information about the Casino Games, including but not limited to information on stakes and odds,
          can be
          found on the Website.
        </li>
      </ol>
    </li>
    <li>PRIZES AND PAYMENTS
      <ol>
        <li>Winnings will be credited to Player's Account following the completion of the concerned Casino Game.</li>
        <li>
          If funds are credited to your Player’s Account in error, it is your responsibility to notify Edgeless of
          the
          error without delay. Any winnings subsequent to the error are deemed invalid and shall be returned to
          Edgeless.
        </li>
        <li>
          You are solely responsible for payment of taxes and levies applicable to any prize. 4. You can withdraw
          funds
          from your Personal Account by clicking the designated button in your Personal Account. Edgeless will endeavor
          to
          pay out withdrawals within 24 hours. However in some cases withdrawals may take longer depending, among
          others, on
          the state of the Blockchain.
        </li>
      </ol>
    </li>
    <li>INTERRUPTED AND CANCELLED GAMES
      <ol>
        <li>
          In the event of a Casino Game malfunction due a failure of Edgeless’ Services , all related results of the
          Casino Game are considered null and void, and the Player's Account will be returned to its starting balance,
          i.e.
          the account balance prior to the malfunctioning.
        </li>
        <li>
          If Edgeless suspects fraudulent activity in any particular Casino Game, Edgeless has the right to cancel
          the
          concerned Casino Game. Suspicious players in respect of the fraudulent activity will have their Personal
          Account
          blocked until further investigations. Players not suspected will receive a full refund of their Edgeless
          Tokens
          invested in the cancelled Casino Game into their Player’s Accounts. Any suspicious activity may be reported to
          the
          concerned gaming regulator and/or law enforcement authorities.
        </li>
        <li>
          Edgeless has the right to close a Casino Game immediately if an error has occurred in the relating game
          settings. Players will receive a full refund of their Edgeless Tokens invested in the closed Casino Game in
          their
          Player’s Account.
        </li>
      </ol>
    </li>
    <li>CUSTOMER SUPPORT
      <ol>
        <li>
          A customer support team (“Customer Support”) will provide support to the Website. Customer Support will
          consist
          of live chat and email support.
        </li>
        <li>You may send any question, concern or complaint to support@edgeless.io.</li>
      </ol>
    </li>
    <li>PROHIBITED JURISDICTIONS
      <ol>
        <li>
          You must be aware of the local laws of your country of residence or the country where you are staying or
          where
          you use the Services regarding the placement of bets or the participation in online gaming.
        </li>
        <li>You must also be aware that legal requirements vary from country to country.</li>
        <li>
          You accept sole responsibility and liability for complying with and fulfilling all obligations concerning
          the
          applicable jurisdiction and to verify whether it is prohibited in your country of residence or stay or use to
          access the Website and use the Services (“Prohibited Jurisdiction”).
        </li>
        <li>
          You may not use any mechanism to access the Website from Prohibited Jurisdictions, including but not
          limited to
          Aruba, Bonaire, Curacao, France, the Netherlands, Saba, Singapore, Statia, St. Maarten, United Kingdom and the
          United States of America. Any attempt to such access via any kind of proxy will be considered fraud.
        </li>
        <li>
          If we discover that you are illegally accessing the Website from a Prohibited Jurisdiction, you will
          automatically be blocked from your Player’s Account, including but not limited to your account balance.
        </li>
        <li>
          Should you have any inquiry concerning Prohibited Jurisdictions, you may contact Customer Support
          support@edgeless.io.
        </li>
      </ol>
    </li>
    <li>RESPONSIBLE GAMING
      <ol>
        <li>
          We trust that you will use our Services in a responsible manner. Playing the Endless Casino Games should be
          for
          entertainment purposes only and should not be regarded as a source of income. You must realize that gaming can
          be
          addictive.
        </li>
        <li>
          If you are losing more money than you can afford or if your gaming habits start to interfere with your
          daily
          routine, we advise you to either (i) establish limits on the amount you spend during a certain period, select
          a
          time-out period or exclude yourself from playing with Edgeless in your “Account Settings” or (ii) exclude
          yourself
          by sending a request to Customer Support support@edgeless.io.
        </li>
        <li>Once you have chosen to exclude yourself, you are prohibited to re-open your account for any reason.</li>
        <li>Get help if gaming becomes a problem. You may contact an online service, such as
          www.gamblingtherapy.org.
        </li>
        <li></li>
      </ol>
    </li>
    <li>TERMINATION
      <ol>
        <li>
          Edgeless reserves the right to terminate your Player's Account and/or the Services provided with immediate
          effect and without prior notice if you fail to comply with any provision in these Terms.
        </li>
        <li>
          In case your Player's Account is terminated you are no longer allowed to access the Website and use the
          Services.
        </li>
        <li>Any winnings obtained after the date of breach of the Terms will be forfeited to Edgeless.</li>
      </ol>
    </li>
    <li>PERSONAL DATA
      <ol>
        <li>Edgeless is committed to protect your Personal Data, which will be kept confidential.</li>
        <li>
          Under applicable laws and gaming regulations Edgeless is required to maintain a secure online list of all
          registered players which may be disclosed to the authorities for scrutiny purposes. Therefore, Personal Data
          and
          gaming transactions will not be deleted even if a Player's Account is closed. Edgeless may retain Personal
          Data
          for the period that is required in accordance with applicable laws and gaming regulations.
        </li>
        <li>
          Customer Support representatives and other Edgeless employees or agents have access to the above mentioned
          data
          in order to provide quality customer service and to administer Edgeless’ business activities.
        </li>
        <li>
          For the purposes of applicable data protection legislation you hereby consent to the processing of any and
          all
          personal data (in manual, electronic or any other form) in connection with the player's transactions in
          relation
          to Edgeless. With this approval Edgeless is allowed to use personal details for marketing purposes. Edgeless
          undertakes that it shall not process any Personal Data for any purpose other than for administrating your
          transactions with Edgeless and for marketing as approved by you.
        </li>
        <li>
          Edgeless has the right to disclose the Personal Data to third parties if (i) it is required to do so
          by
          law or any regulatory requirement, or (ii) it is deemed necessary to protect the safety of other users of the
          Services or the general public, or (iii) you are under investigation of any suspected fraud and/or unlawful
          activity.
        </li>
        <li>
          Upon accessing the Website “cookies” will be placed on the hard drive of your computer or device. Edgeless
          uses
          cookies to provide a better gaming experience and faster browsing. We are not collecting any Personal Data
          from
          you when using cookies. You can modify the settings of your cookies via your Internet browser. However, such
          modification may result in the inability to use the Services.
        </li>
      </ol>
    </li>
    <li>INTELLECTUAL PROPERTY
      <ol>
        <li>
          All content on the Website, including but not limited to text, graphics, logos, button icons, images, audio
          clips, digital downloads and software is owned or licensed by Edgeless and may not be copied, altered,
          distributed
          or displayed without the prior written approval of Edgeless.
        </li>
        <li>
          Edgeless's trademarks, trade names and other marks shown used in connection with the Services and used on
          the
          Website are protected by national and international trademark laws. Any and all use of these marks is strictly
          prohibited without the prior written approval of Edgeless.
        </li>
      </ol>
    </li>
    <li>DISCLAIMER
      <ol>
        <li>
          Your use of the Services is at your own risk. The services are provided on an "as is" and "as available"
          basis.
          You understand that by participating in the Casino Games you take the risk of losing all funds deposited into
          your
          Personal Account.
        </li>
        <li>
          You are aware the Services are based on blockchain technology, which is not in any way controlled by
          Edgeless.
          Edgeless, its officers, directors, employees, shareholders, parents, subsidiaries, affiliates, licensors, and
          agents are not responsible for any hack, malfunction, system breach, wallet hack, attack or any other
          intrusion of
          the Website and/or the Blockchain. You understand that security breaches may occur, wallets are being hacked
          and
          tokens are being stolen and you risk to lose Edgeless Tokens. Edgeless, its officers, directors, employees,
          shareholders, parents, subsidiaries, affiliates, licensors, and agents are not liable in any capacity if
          Edgeless
          Tokens are stolen or lost in any way.
        </li>
        <li>
          Edgeless, its officers, directors, employees, shareholders, parents, subsidiaries, affiliates, licensors,
          and
          agents hereby expressly disclaim any and all representations and warranties of every kind, whether express or
          implied, regarding the Website and the Services and any information or other materials provided by Edgeless in
          connection with the use of the Services, including but not limited to warranties of merchantability, fitness
          for a
          particular purpose, non-infringement and those warranties arising by law, statute, usage of trade, or course
          of
          dealing.
        </li>
        <li>
          ny material and/or data downloaded or otherwise obtained through use of the Services is at your own
          discretion
          and risk. You will be solely responsible for any damages to your computer system and any other property item
          or
          loss of data that results from any such activity.&nbsp;
        </li>
      </ol>
    </li>
    <li>INDEMNIFICATION AND LIMITATION OF LIABILITY
      <ol>
        <li>
          Edgeless, or its officers, directors, employees, shareholders, parents, subsidiaries, affiliates, agents,
          partners or licensors, shall not be liable for any injury, loss, claim, damage or any indirect, incidental,
          special, punitive or consequential damages of any kind, or any damages whatsoever, including but not limited
          to,
          damages for loss of income, use, data, goodwill or other intangibles, arising out of or in connection with
          your
          use or inability to use the Services, including but not limited to delays or interruptions in operation or
          transmission, loss or corruption of data, communication or line failure, any person's misuse of the site or
          its
          content, any errors or omissions in content or delays, errors, malfunctioning or illegal activity on the
          Blockchain.
        </li>
        <li>If you are dissatisfied with the Services you may discontinue the use thereof.</li>
        <li>
          In the event Edgeless or its officers, directors, employees, shareholders, parents, subsidiaries,
          affiliates,
          agents, partners or licensors should be found liable for any loss or damage which arises out of or is in any
          way
          connected to the Services, the liability of Edgeless, or its officers, directors, employees, shareholders,
          parents, subsidiaries, affiliates, agents, partners or licensors shall in no event exceed the value of the
          bets
          you placed via your Player’s Account in respect of the concerned bet on the Casino Game that gave rise to the
          relevant liability.
        </li>
        <li>
          Edgeless shall not be liable for any loss or corruption of data or content during the use of the Services,
          including but not limited to network, system or server failures, power outages, or damage caused due to
          viruses,
          worms or security breaches.
        </li>
        <li>
          Edgeless assumes no liability for any damages due to worms or viruses that may infect your computer
          equipment
          or other property on account of your access to or use of the Services.
        </li>
      </ol>
    </li>
    <li>FORCE MAJEURE
      <ol>
        <li>
          Any failure or delay by Edgeless in the performance of its obligations of its services shall not be deemed
          a
          breach of its obligations to you if such failure or delay to the extent is caused by fire, flood, earthquake,
          elements of nature, public utility electrical failure, acts of war, terrorism, riots, civil disorders,
          rebellions
          or revolutions, strikes, lockouts, or labor difficulties, court order, outage, delays or disruptions of the
          Internet or telecommunications networks, third party nonperformance or any other similar cause beyond the
          reasonable control of Edgeless.
        </li>
        <li>Edgeless does not accept any liability for the consequences arising out of any force majeure event.</li>
      </ol>
    </li>
  </ol>

  <p>Version: February 2018</p>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/legal/legals/terms-and-conditions.component.html